import DOMPurify from 'dompurify';
import React, { useEffect } from 'react';
import { useQuill } from 'react-quilljs';

import 'quill/dist/quill.snow.css';
import { RichTextEditorProps } from './RichTextEditor.props';
import { StyledReactQuill } from './RichTextEditor.styles';

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onValueChange,
  readOnly,
  error
}) => {
  const { quill, quillRef } = useQuill({
    readOnly,
    theme: 'snow',
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        ['clean'],
      ],
    },
    formats: [
      'header',
      'bold',
      'italic',
      'underline',
      'strike',
      'blockquote',
      'list',
      'indent',
      'script',
      'color',
      'background',
      'link',
      'image',
    ]
  });

  useEffect(() => {
    if (quill) {
      quill.clipboard.dangerouslyPasteHTML(DOMPurify.sanitize(value || ''));
      quill.blur();
      quill.on('text-change', () => {
        const html = quill.root.innerHTML;
        onValueChange && onValueChange(html);
      });
    }
  }, [quill]);

  useEffect(() => {
    if (!value && quill) {
      quill.setText('');
    }
  }, [value]);

  return (
    <div style={StyledReactQuill(!!error)}>
      <div ref={quillRef} />
    </div>
  );
};